<template>
  <div>
    <Header :navbar="'courseDetail'" @navTarget="goHome"></Header>
    <div class="page-container11">
      <div class="page-wrapper">
        <div class="page-back-wrapper">
          <div class="page-back">
            <img src="@/assets/img/back.png" alt="" class="page-back-img" />
            <span @click="goToLearn">返回</span>

            <span style="margin: 0 8px 0 8px"></span>
            <span>{{ testInfo.title }}</span>
            <span style="margin: 0 8px 0 8px"> > </span>
            <span>{{ testInfo.title2 }}</span>
          </div>
          <!-- <div class="page-title">{{ exerciseData.title }}</div> -->
        </div>

        <div class="content-container">
          <!-- <div class="headT">
            <div class="page-back">
              <img src="@/assets/img/back.png" alt="" class="page-back-img" @click="goToLearn" />
              <span @click="goToLearn">返回</span>
              <span style="margin: 0 8px 0 8px"></span>
              <span>{{ testInfo.title }}</span>
              <span style="margin: 0 8px 0 8px"> > </span>
              <span>{{ testInfo.title2 }}</span>

            </div>
          </div> -->
          <div class="content-left-container">
            <div class="content-left-wrapper">
              <div class="exercise-wrapper">
                <div class="question-area">
                  <!-- Display the current question here -->
                  <div v-if="currentQuestion">
                    <h2>
                      {{
                        currentQuestion.type === "radio"
                        ? "单选题"
                        : currentQuestion.type === "checkbox"
                          ? "多选题"
                          : currentQuestion.type === "decide"
                            ? "判断题"
                            : ""
                      }}
                    </h2>
                    <div style="font-size:18px;max-height: 99px;overflow-y: auto;">
                      {{ currentQuestionIndex + 1 }}/{{ questions.length }}.{{
                        currentQuestion.subject
                      }}
                    </div>
                    <ul style="font-size: 20px" class="cwlist">
                      <li v-if="currentQuestion.type === 'radio'" v-for="option in currentQuestionOptions">
                        <div v-if="!isResult">
                          <!-- <input type="radio" :value="option" v-model="userAnswer"
                            @change="selectAnswerChange('radio')" />
                          {{ option.value }} -->
                          <el-radio :disabled="jsshow" @input="selectAnswerChange('radio')"
                            style="font-size:20px;width:600px;height: auto;white-space: pre-wrap; line-height: 40px;background: #f8f8f8;border-radius: 3px;"
                            v-model="userAnswer" :label="option">{{ option.key }}:{{
                              option.value }}</el-radio>
                        </div>
                        <div v-else>
                          <div v-if="option.key == currentQuestion.correct" class="c-28bebe">
                            <img style="margin-left: 10px;" src="@/assets/img/option2.png" alt="" width="14">
                            {{ option.value }}
                          </div>
                          <div
                            v-else-if="currentQuestion.correct !== currentQuestion.userAnswer && option.key == currentQuestion.userAnswer"
                            class="c-eb6c48">
                            <img style="margin-left: 10px;" src="@/assets/img/option1.png" alt="" width="14">
                            {{ option.value }}
                          </div>
                          <div v-else>
                            <img style="margin-left: 10px;" src="@/assets/img/option3.png" alt="" width="14">
                            {{ option.value }}
                          </div>
                        </div>
                      </li>
                      <li v-if="currentQuestion.type === 'checkbox'" v-for="option in currentQuestionOptions">
                        <!--                        <input-->
                        <!--                          type="checkbox"-->
                        <!--                          :value="option"-->
                        <!--                          v-model="userAnswerArray"-->
                        <!--                        />-->
                        <!--                        {{ option }}-->

                        <div v-if="!isResult">
                          <!-- <input type="checkbox" :value="option" v-model="userAnswerArray"
                            @change="selectAnswerChange('checkbox')" />
                          {{ option.value }} -->
                          <el-checkbox :disabled="jsshow"
                            style="font-size:20px;width:600px;height: auto; margin-bottom: 10px;background: #f8f8f8;border-radius: 3px;"
                            @change="selectAnswerChange('checkbox')" v-model="userAnswerArray" :label="option"
                            size="medium">{{ option.key }}:{{
                              option.value
                            }}</el-checkbox>
                        </div>
                        <div v-else>
                          <div v-if="currentQuestion.correct.includes(option.key)" class="c-28bebe">
                            <img style="margin-left: 10px;" src="@/assets/img/option2.png" alt="" width="14">
                            {{ option.value }}
                          </div>
                          <div
                            v-else-if="currentQuestion.userAnswer && currentQuestion.correct !== currentQuestion.userAnswer && currentQuestion.userAnswer.includes(option.key)"
                            class="c-eb6c48">
                            <img style="margin-left: 10px;" src="@/assets/img/option1.png" alt="" width="14">
                            {{ option.value }}
                          </div>
                          <div v-else>
                            <img style="margin-left: 10px;" src="@/assets/img/option3.png" alt="" width="14">
                            {{ option.value }}
                          </div>
                        </div>
                      </li>
                      <li v-if="currentQuestion.type === 'decide'" v-for="option in currentQuestionOptions">
                        <!--                        <input-->
                        <!--                          type="radio"-->
                        <!--                          :value="option"-->
                        <!--                          v-model="userAnswer"-->
                        <!--                        />-->
                        <!--                        {{ option }}-->
                        <div v-if="!isResult">
                          <!-- <input type="radio" :value="option" v-model="userAnswer"
                            @change="selectAnswerChange('radio')" />
                          {{ option.value }} -->
                          <el-radio :disabled="jsshow" @input="selectAnswerChange('radio')"
                            style="font-size:20px;width:600px;height: auto;white-space: pre-wrap; line-height: 40px;background: #f8f8f8;border-radius: 3px;"
                            v-model="userAnswer" :label="option">{{
                              option.value }}</el-radio>
                        </div>
                        <div v-else>
                          <div v-if="option.key == currentQuestion.correct" class="c-28bebe">
                            <img style="margin-left: 10px;" src="@/assets/img/option2.png" alt="" width="14">
                            {{ option.value }}
                          </div>
                          <div
                            v-else-if="currentQuestion.correct !== currentQuestion.userAnswer && option.key == currentQuestion.userAnswer"
                            class="c-eb6c48">
                            <img style="margin-left: 10px;" src="@/assets/img/option1.png" alt="" width="14">
                            {{ option.value }}
                          </div>
                          <div v-else>
                            <img style="margin-left: 10px;" src="@/assets/img/option3.png" alt="" width="14">
                            {{ option.value }}
                          </div>
                        </div>
                      </li>
                      <div v-if="jsshow" class="jx">
                        <div class="zq" v-if="arraysAreEqual(currentQuestion.userAnswer, currentQuestion.correct)

                        ">
                          回答正确 <i class="el-icon-check"></i>

                        </div>
                        <div v-else class="cw">回答错误 <i class="el-icon-close"></i>
                        </div>
                        <div class="mayDn">
                          <div class="mylist">
                            <div style="margin-bottom: 5px;">正确答案</div>
                            <div style="color: #28bebe;">{{ currentQuestion.correct }}</div>
                          </div>
                          <div class="mylist">
                            <div style="margin-bottom: 5px;">我的答案</div>
                            <div style="color:#28bebe ;" v-if="arraysAreEqual(currentQuestion.userAnswer, currentQuestion.correct)

                            "> {{ sortOBJ(currentQuestion.userAnswer) }}</div>
                            <div style="color:red;" v-else>{{
                              sortOBJ(currentQuestion.userAnswer) }}</div>
                          </div>
                          <div class="mylist" @click="isExpanded = !isExpanded">
                            <i v-if="isExpanded" class="el-icon-caret-top "></i>
                            <i v-else class="el-icon-caret-bottom"></i>{{ isExpanded
                              ?
                              "收起解析"
                              :
                              "展开解析"
                            }}
                          </div>
                          <div></div>
                        </div>
                        <div>
                          <div v-if="isExpanded" class="contenttexte" style="font-size: 18px;">
                            <div> <i class="el-icon-document"></i>参考解析</div>
                            <!-- 这里是展开后要显示的内容 -->
                            {{ currentQuestion.explanation ? currentQuestion.explanation : '无' }}
                          </div>
                        </div>
                      </div>
                    </ul>
                    <!-- v-if="currentQuestionIndex > 0" -->
                    <div style="display: flex; justify-content: space-around">
                      <div class="exercise-submit-btn" @click="upQuestion" style="width: 100px;">
                        上一题
                      </div>
                      <div class="exercise-submit-btn" @click="nextQuestion" style="width: 100px">
                        下一题
                      </div>
                      <div class="exercise-submit-btn" @click="setshwo" style="width: 100px">
                        解析
                      </div>
                    </div>
                    <!-- <div
                      v-else
                      class="exercise-submit-btn"
                      @click="nextQuestion"
                    >
                      下一题
                    </div> -->
                  </div>
                  <div v-else>
                    <p v-if="questions.length === 0">试题正在更新中，请耐心等待!</p>
                    <p v-else>已是最后一题，是否确认提交！</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-right-container">
            <div v-if="questions.length > 0" class="content-right-wrapper">
              <div class="content-left-title">答题卡</div>
              <div v-if="questions.filter((x) => { return x.type == 'radio'; }).length > 0" class="exercise-title">
                单选题
                <div class="exercise-right-line"></div>
              </div>
              <div v-for="(question, index) in questions.filter((x) => {
                return x.type == 'radio';
              })" :key="question.id" class="exercise-answer-info-circle question-info" :class="{
  'circle-right': question.userAnswer,
  'circle-gap': !question.userAnswer,
}" @click="onSelect(index, question.userAnswer ? true : false, 'radio')">
                <div v-if="!isResult" class="yz">
                  {{ index + 1 }}
                </div>
                <div v-else>
                  <!--                  {{question.userAnswer}}-{{question.correct}}-->
                  <div v-if="question.userAnswer && question.userAnswer == question.correct" class="back-28bebe">{{ index
                    + 1
                  }}</div>
                  <div v-if="question.userAnswer && question.userAnswer !== question.correct" class="back-eb6c48">{{ index
                    + 1
                  }}</div>
                  <div v-if="!question.userAnswer">{{ index + 1 }}</div>
                </div>
              </div>
              <div v-if="questions.filter((x) => { return x.type == 'checkbox'; }).length > 0" class="exercise-title">
                多选题
                <div class="exercise-right-line"></div>
              </div>

              <div v-for="(question, index) in questions.filter((x) => {
                return x.type == 'checkbox';
              })" :key="question.id" class="exercise-answer-info-circle question-info" :class="{
  'circle-right': question.userAnswer,
  'circle-gap': !question.userAnswer,
}" @click="onSelect(index, question.userAnswer ? true : false, 'checkbox')">
                <div v-if="!isResult" class="yz">
                  {{ index + 1 + questions.filter((x) => { return x.type == 'radio'; }).length }}
                </div>
                <div v-else>
                  <!-- 修改问题（wyh 上面代码是备份有问题课还原) checkAnswer(question.userAnswer, question.correct) -->
                  <div v-if="question.userAnswer && arraysAreEqual(question.userAnswer, question.correct)"
                    class="back-28bebe">
                    {{ index + 1 + questions.filter((x) => { return x.type == 'radio'; }).length }}</div>
                  <!-- 修改问题（wyh 上面代码是备份有问题课还原) checkAnswer(question.userAnswer, question.correct) -->
                  <div v-if="question.userAnswer && !arraysAreEqual(question.userAnswer, question.correct)"
                    class="back-eb6c48">{{ index + 1 + questions.filter((x) => { return x.type == 'radio'; }).length }}
                  </div>
                  <div v-if="!question.userAnswer">{{ index + 1 + questions.filter((x) => {
                    return x.type ==
                      'radio';
                  }).length }}</div>
                </div>
              </div>

              <div v-if="questions.filter((x) => { return x.type == 'decide'; }).length > 0" class="exercise-title">
                判断题
                <div class="exercise-right-line"></div>
              </div>

              <div v-for="(question, index) in questions.filter((x) => {
                return x.type == 'decide';
              })" :key="question.id" class="exercise-answer-info-circle question-info" :class="{
  'circle-right': question.userAnswer,
  'circle-gap': !question.userAnswer,
}" @click="onSelect(index, question.userAnswer ? true : false, 'decide')">
                <div v-if="!isResult" class="yz">
                  {{ index + 1 + questions.filter((x) => { return x.type == 'radio'; }).length + questions.filter((x) => {
                    return x.type == 'checkbox';
                  }).length }}
                </div>
                <div v-else>
                  <div v-if="question.userAnswer && question.userAnswer == question.correct" class="back-28bebe">{{ index
                    + 1
                    + questions.filter((x) => { return x.type == 'radio'; }).length + questions.filter((x) => {
                      return
                      x.type == 'checkbox';
                    }).length }}</div>
                  <div v-if="question.userAnswer && question.userAnswer !== question.correct" class="back-eb6c48">{{ index
                    + 1
                    + questions.filter((x) => { return x.type == 'radio'; }).length + questions.filter((x) => {
                      return
                      x.type == 'checkbox';
                    }).length }}</div>
                  <div v-if="!question.userAnswer">{{ index + 1 + questions.filter((x) => {
                    return x.type ==
                      'radio';
                  }).length + questions.filter((x) => { return x.type == 'checkbox'; }).length }}</div>
                </div>
              </div>

              <div v-if="!isResult" class="exercise-answer-info-wrapper">
                <div class="exercise-answer-info">
                  <div class="exercise-answer-info-circle "
                    style="background: #FF9645;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          border: solid #FF9645 1px;">
                  </div>
                  <div class="exercise-answer-info-label">已做</div>
                </div>
                <div class="exercise-answer-info">
                  <div class="exercise-answer-info-circle circle3 circle-gap"></div>
                  <div class="exercise-answer-info-label">未做</div>
                </div>
              </div>

              <div v-if="isResult" class="exercise-answer-info-wrapper">
                <div class="exercise-answer-info">
                  <div class="exercise-answer-info-circle circle-r"></div>
                  <div class="exercise-answer-info-label">正确</div>
                </div>
                <div class="exercise-answer-info">
                  <div class="exercise-answer-info-circle  circle-gap"
                    style="background: #eb6c48;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            border: solid #eb6c48 1px;">
                  </div>
                  <div class="exercise-answer-info-label">错误</div>
                </div>
                <div class="exercise-answer-info">
                  <div class="exercise-answer-info-circle circle3 circle-gap"></div>
                  <div class="exercise-answer-info-label">未做</div>
                </div>
              </div>

              <div v-if="!isResult" class="exercise-submit-btn" @click="submitExercise">
                提交
              </div>
              <div v-else class="exercise-submit-btn" @click="reTest">
                再次练习
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="测试报告" :visible="dialogVisible" @close="dialogVisible = false" :close-on-click-modal="false"
      width="500px">
      <div class="result-container" style="display: flex; flex-direction: column; align-items: center">
        <div class="rate" style="margin-bottom: 60px">
          <el-progress type="circle" :stroke-width="10" :percentage="parseFloat(scoreData.accuracy.replace('%', ''))">
          </el-progress>
          <div style="text-align: center; margin-top: -53px">正确率</div>
        </div>
        <div class="subit-time" style="font-weight: bold; margin-bottom: 20px; color: #b3b3b3;">
          正确率=做对数量/已做数量
        </div>
        <div class="subit-time" style="font-weight: bold; margin-bottom: 20px">
          提交时间：{{ scoreData.time }}
        </div>

        <ul class="details"
          style="
                                                                                                                                                                                                                                                                                                                                                                                                                      display: flex;
                                                                                                                                                                                                                                                                                                                                                                                                                      justify-content: space-between;
                                                                                                                                                                                                                                                                                                                                                                                                                      width: 221px;
                                                                                                                                                                                                                                                                                                                                                                                                                      text-align: center;
                                                                                                                                                                                                                                                                                                                                                                                                                      color: #b3b3b3;
                                                                                                                                                                                                                                                                                                                                                                                                                      margin-bottom: 20px;">
          <li>
            <div>做对</div>
            <div>{{ scoreData.rightNum }}</div>
          </li>
          <li>
            <div>做错</div>
            <div>{{ scoreData.wrongNum }}</div>
          </li>
          <li>
            <div>未做</div>
            <div>{{ scoreData.nonNum }}</div>
          </li>
        </ul>

        <div class="buttons">
          <el-button @click="reTest">再次练习</el-button>
          <el-button @click="viewDetail">查看详情</el-button>
          <el-button @click="goToLearn">返回学习</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import {
  submitExerciseResult,
  getExerciseList,
  getPaperResult
} from "@/api/index.js";

export default {
  components: {
    Header
  },
  data() {
    return {
      isExpanded: true, // 控制展开收起状态的数据
      jsshow: false,
      testInfo: {
        title: "",
        title2: ""
      },
      currentQuestionIndex: 0,
      currentQuestion: null,
      currentQuestionOptions: [],
      userAnswer: null,
      userAnswerArray: [],
      answeredQuestions: [],
      contentsId: "",
      scoreData: { wrongNum: 1, accuracy: "80.0%", rightNum: 4, nonNum: 0 },
      dialogVisible: false,
      exerciseData: {
        radio: [],
        checkbox: [],
        decide: []
      },
      isResult: false
    };
  },
  computed: {
    questions() {
      return [
        ...this.exerciseData.radio,
        ...this.exerciseData.checkbox,
        ...this.exerciseData.decide
      ];
    },
    sortOBJ() {
      return callRecord => {
        if (typeof callRecord !== 'string') return '';
        return [...new Set(
          callRecord
            .split(',')
            .map(item => item.trim())
            .filter(Boolean)
        )]
          .sort((a, b) => a.localeCompare(b))
          .join(',');
      };
    },
  },
  mounted() {
    //课程标题章节
    this.testInfo = JSON.parse(localStorage.getItem("testInfo"))
    this.contentsId = this.$route.params.contentsId;
    this.dept = window.localStorage.getItem("dept");
    this.token = window.localStorage.getItem("token");
    this.getAllExercises();
  },
  methods: {
    // arraysAreEqual(arr1, arr2) {
    //   console.log(arr1, '99999999999999')
    //   var a = arr1 ? arr1.split("") : ""
    //   var b = arr2 ? arr2.split("") : ""

    //   return JSON.stringify(a ? a.sort() : a) === JSON.stringify(b ? b.sort() : b);
    // },
    /* 深度比较两个数组是否相等（考虑去重和排序）
    * @param { Array } arr1 - 第一个比较数组
      * @param { Array } arr2 - 第二个比较数组
        * @returns { boolean } 是否包含相同元素（无关顺序）
    */
    arraysAreEqual(arr1, arr2) {
      // 空数组特殊处理
      if (arr1.length === 0 && arr2.length === 0) return true;

      // 高效去重排序比较
      const normalize = arr =>
        [...new Set(arr)]
          .filter(x => x !== undefined && x !== null)
          .sort((a, b) => (a > b ? 1 : -1));

      const a = normalize(arr1);
      const b = normalize(arr2);

      return a.length === b.length &&
        a.every((val, idx) => val === b[idx]);
    },
    setshwo() {
      this.jsshow = !this.jsshow;
      console.log(this.jsshow, " this.jsshow");
    },
    goHome(params) {
      // console.log(params, "params");
      // history.back();
      this.$router.push({
        path: "/",
        query: {
          navbarType: params
        }
      });
    },
    getAllExercises() {
      getExerciseList(
        {
          contentsId: this.contentsId
        },
        {
          Authorization: this.token,
          DeptId: this.dept
        }
      )
        .then(res => {
          if (res.code == 200) {
            this.exerciseData = res.data;
            this.getNextQuestion();
          }
          return;
        })
        .catch(err => {
          // console.log(err);
        });
    },

    // getNextQuestion2() {
    //   const questionTypes = ["radio", "checkbox", "decide"]; // Change the order here
    //   for (const type of questionTypes) {
    //     const questions = this.exerciseData[type];
    //     for (const question of questions) {
    //       if (question.userAnswer === null) {
    //         this.currentQuestion = question;
    //        // console.log(this.currentQuestion);
    //         this.currentQuestionOptions = [];
    //         if (question.answerA) {
    //           this.currentQuestionOptions.push(question.answerA);
    //         }
    //         if (question.answerB) {
    //           this.currentQuestionOptions.push(question.answerB);
    //         }
    //
    //         if (question.answerC) {
    //           this.currentQuestionOptions.push(question.answerC);
    //         }
    //
    //         if (question.answerD) {
    //           this.currentQuestionOptions.push(question.answerD);
    //         }
    //
    //         return;
    //       }
    //     }
    //   }
    //   this.currentQuestion = null;
    // },
    onSelect(i, isRight, t) {
      let userAnswerArrayData = JSON.parse(
        JSON.stringify(this.userAnswerArray)
      );
      if (t === "radio") {
        this.currentQuestionIndex = i;
      } else if (t === "checkbox") {
        this.currentQuestionIndex = this.exerciseData.radio.length + i;
      } else {
        this.currentQuestionIndex =
          this.exerciseData.radio.length +
          this.exerciseData.checkbox.length +
          i;
      }
      if (!this.isResult && (this.userAnswer || this.userAnswerArray)) {
        let answerData = null;
        if (
          this.currentQuestion.type === "radio" ||
          this.currentQuestion.type === "decide"
        ) {
          if (this.userAnswer) {
            // If it's a radio type, record the selected option as the user's answer
            answerData = ["A", "B", "C", "D"][
              this.currentQuestionOptions.findIndex(
                option => option.key === this.userAnswer.key
              )
            ];
          }
        } else if (this.currentQuestion.type === "checkbox") {
          // let answers = [];
          // this.userAnswerArray.forEach((answer) => {
          //   answers.push(
          //       ["A", "B", "C", "D"][
          //           this.currentQuestionOptions.findIndex(
          //               (option) => option === answer
          //           )
          //           ]
          //   );
          // });
          // answers=answers.filter((res) => {
          //   return res != undefined
          // })
          // answerData = answers.join(",");let answers = [];
          let answers = [];
          if (userAnswerArrayData[0]?.key) {
            userAnswerArrayData.forEach(answer => {
              answers.push(
                ["A", "B", "C", "D"][
                this.currentQuestionOptions.findIndex(
                  option =>
                    option.key === answer.key && option.value === answer.value
                )
                ]
              );
            });
          } else {
            userAnswerArrayData.forEach(answer => {
              answers.push(
                ["A", "B", "C", "D"][
                this.currentQuestionOptions.findIndex(
                  option => option === answer
                )
                ]
              );
            });
          }
          answers = answers.filter(res => {
            return res != undefined;
          });
          answerData = answers.join(",");
          this.userAnswerArray = [];
          if (userAnswerArrayData[0]?.key) {
            userAnswerArrayData.forEach(answer => {
              answers.push(
                ["A", "B", "C", "D"][
                this.currentQuestionOptions.findIndex(
                  option =>
                    option.key === answer.key && option.value === answer.value
                )
                ]
              );
            });
          } else {
            userAnswerArrayData.forEach(answer => {
              answers.push(
                ["A", "B", "C", "D"][
                this.currentQuestionOptions.findIndex(
                  option => option === answer
                )
                ]
              );
            });
          }
          answers = answers.filter(res => {
            return res != undefined;
          });
          answerData = answers.join(",");
        }
        this.currentQuestion.userAnswer = answerData;
        let index = this.answeredQuestions.findIndex(item => {
          return item.id === this.currentQuestion.id;
        });
        if (index === -1) {
          this.answeredQuestions.push(this.currentQuestion);
        } else {
          this.answeredQuestions[index].userAnswer = answerData;
        }
        this.userAnswer = null;
      }
      if (isRight) {
        this.getNextQuestion("next");
      } else {
        this.getNextQuestion();
      }
    },
    getNextQuestion(type) {
      let exerciseData = [];
      const questionTypes = ["radio", "checkbox", "decide"]; // Change the order here
      for (const type of questionTypes) {
        const questions = this.exerciseData[type];
        for (const question of questions) {
          exerciseData.push(question);
        }
      }
      // console.log(exerciseData);
      let question = exerciseData[this.currentQuestionIndex];
      this.currentQuestion = question;
      this.currentQuestionOptions = [];
      if (question.answerA) {
        this.currentQuestionOptions.push({
          key: "A",
          value: question.answerA
        });
      }
      if (question.answerB) {
        this.currentQuestionOptions.push({
          key: "B",
          value: question.answerB
        });
      }

      if (question.answerC) {
        this.currentQuestionOptions.push({
          key: "C",
          value: question.answerC
        });
      }

      if (question.answerD) {
        this.currentQuestionOptions.push({
          key: "D",
          value: question.answerD
        });
      }
      if (type === "next" && this.currentQuestion.userAnswer) {
        this.userAnswer = this.currentQuestion.userAnswer;
        if (
          this.currentQuestion.type === "radio" ||
          this.currentQuestion.type === "decide"
        ) {
          this.userAnswer = this.currentQuestionOptions.find(
            option => option.key === this.userAnswer
          );
        } else if (this.currentQuestion.type === "checkbox") {
          let a = this.userAnswer.split(",");
          let newList = Array.from(new Set(a));
          let answers = [];
          newList.forEach(answer => {
            let index = this.currentQuestionOptions.findIndex(
              option => option.key === answer
            );
            answers.push(this.currentQuestionOptions[index]);
          });
          this.userAnswerArray = answers;
        }
      }
      // console.log(this.currentQuestion);
      // console.log("this.userAnswer", this.userAnswer);
    },

    previousQuestion() { },
    checkAnswer(user, correct) {
      let userData = user.split(",");
      let correctData = correct.split(",");
      let res = false;
      if (userData.length === correctData.length) {
        var c = userData.filter(t => !correctData.includes(t));
        if (c.length === 0) res = true;
      }
      return res;
    },
    //上一题
    upQuestion() {
      if (!this.isResult) {
        this.jsshow = false
      }
      if (this.currentQuestionIndex == 0) {
        this.$message({
          message: '这是第一题',
          type: 'warning'
        });
        return
      }
      let userAnswerArrayData = JSON.parse(
        JSON.stringify(this.userAnswerArray)
      );
      if (this.userAnswer || this.userAnswerArray) {
        let answerData = null;
        if (
          this.currentQuestion.type === "radio" ||
          this.currentQuestion.type === "decide"
        ) {
          if (this.userAnswer) {
            // If it's a radio type, record the selected option as the user's answer
            answerData = ["A", "B", "C", "D"][
              this.currentQuestionOptions.findIndex(
                option => option.key === this.userAnswer.key
              )
            ];
          }
        } else if (this.currentQuestion.type === "checkbox") {
          let answers = [];
          userAnswerArrayData.forEach(answer => {
            answers.push(
              ["A", "B", "C", "D"][
              this.currentQuestionOptions.findIndex(
                option => option.key === answer.key
              )
              ]
            );
          });
          answers = answers.filter(res => {
            return res != undefined;
          });
          answerData = answers.join(",");
        }
        this.currentQuestion.userAnswer = answerData;
        let index = this.answeredQuestions.findIndex(item => {
          return item.id === this.currentQuestion.id;
        });
        if (index === -1) {
          this.answeredQuestions.push(this.currentQuestion);
        } else {
          this.answeredQuestions[index].userAnswer = answerData;
        }
      }
      this.currentQuestionIndex--;
      let exerciseData = [];
      const questionTypes = ["radio", "checkbox", "decide"]; // Change the order here
      for (const type of questionTypes) {
        const questions = this.exerciseData[type];
        for (const question of questions) {
          exerciseData.push(question);
        }
      }
      // console.log(exerciseData);
      let question = exerciseData[this.currentQuestionIndex];
      this.currentQuestion = question;
      this.userAnswer = this.currentQuestion.userAnswer;
      this.getNextQuestion("next");
      // Check if the current question is a radio or checkbox type
      // if (!this.isResult) {
      //   if (
      //       this.currentQuestion.type === "radio" ||
      //       this.currentQuestion.type === "decide"
      //   ) {
      //       this.userAnswer = this.currentQuestionOptions.find(
      //             (option) => option.key === this.userAnswer
      //         );
      //   } else if (this.currentQuestion.type === "checkbox") {
      //     let answers = [];
      //     if (userAnswerArrayData[0].key) {
      //       userAnswerArrayData.forEach((answer) => {
      //         answers.push(
      //             ["A", "B", "C", "D"][
      //                 this.currentQuestionOptions.findIndex(
      //                     (option) => option.key === answer.key && option.value === answer.value
      //                 )
      //                 ]
      //         );
      //       });
      //     } else {
      //       userAnswerArrayData.forEach((answer) => {
      //         answers.push(
      //             ["A", "B", "C", "D"][
      //                 this.currentQuestionOptions.findIndex(
      //                     (option) => option === answer
      //                 )
      //                 ]
      //         );
      //       });
      //     }
      //     this.userAnswer = answers.join(",");
      //   }
      //  // console.log('asdasd', this.userAnswer)
      //   // this.currentQuestion.userAnswer = this.userAnswer;
      //   // this.answeredQuestions.push(this.currentQuestion);
      //   // this.userAnswer = null;
      // }
    },
    // 选择答案改变
    selectAnswerChange() {
      if (!this.isResult && (this.userAnswer || this.userAnswerArray)) {
        let answerData = null
        if (this.currentQuestion.type === "radio" || this.currentQuestion.type === "decide") {
          // If it's a radio type, record the selected option as the user's answer
          answerData = ["A", "B", "C", "D"][
            this.currentQuestionOptions.findIndex(
              option => option.key === this.userAnswer.key
            )
          ];
        } else if (this.currentQuestion.type === "checkbox") {
          let userAnswerArrayData = JSON.parse(
            JSON.stringify(this.userAnswerArray)
          );
          let answers = [];
          if (userAnswerArrayData[0]?.key) {
            userAnswerArrayData.forEach(answer => {
              answers.push(
                ["A", "B", "C", "D"][
                this.currentQuestionOptions.findIndex(
                  option =>
                    option.key === answer.key && option.value === answer.value
                )
                ]
              );
            });
          } else {
            userAnswerArrayData.forEach(answer => {
              answers.push(
                ["A", "B", "C", "D"][
                this.currentQuestionOptions.findIndex(
                  option => option === answer
                )
                ]
              );
            });
          }
          answers = answers.filter(res => {
            return res != undefined;
          });
          answerData = answers.join(",");
        }
        this.currentQuestion.userAnswer = answerData;
        let index = this.answeredQuestions.findIndex(item => {
          return item.id === this.currentQuestion.id;
        });
        if (index === -1) {
          this.answeredQuestions.push(this.currentQuestion);
        } else {
          this.answeredQuestions[index].userAnswer = answerData;
        }
      }
    },
    //下一题
    nextQuestion() {
      if (!this.isResult) {
        this.jsshow = false
      }
      let _this = this
      let exerciseData = [];
      const questionTypes = ["radio", "checkbox", "decide"]; // Change the order here
      for (const type of questionTypes) {
        const questions = this.exerciseData[type];
        for (const question of questions) {
          exerciseData.push(question);
        }
      }
      // console.log('12312asdasd', exerciseData.length);
      // console.log('12312asdasd', this.currentQuestionIndex);
      // let question = exerciseData[this.currentQuestionIndex];
      if (this.currentQuestionIndex == exerciseData.length - 1) {
        if (this.isResult) {
          this.$message({
            message: '已是最后一题！',
            type: 'warning'
          });
        } else {
          this.$confirm('当前为最后一题，是否确认提交?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',

            center: true
          }).then(() => {
            _this.submitExercise()
          }).catch(() => {
            this.$message({

              message: '已取消'
            });
          });
        }


        return
      }
      // console.log(this.userAnswer);
      let userAnswerArrayData = JSON.parse(
        JSON.stringify(this.userAnswerArray)
      );
      // console.log("userAnswerArrayData", userAnswerArrayData);
      // Check if the current question is a radio or checkbox type
      if (!this.isResult && (this.userAnswer || this.userAnswerArray)) {
        let answerData = null;
        if (
          this.currentQuestion.type === "radio" ||
          this.currentQuestion.type === "decide"
        ) {
          if (this.userAnswer) {
            // If it's a radio type, record the selected option as the user's answer
            answerData = ["A", "B", "C", "D"][
              this.currentQuestionOptions.findIndex(
                option => option.key === this.userAnswer.key
              )
            ];
          }
        } else if (this.currentQuestion.type === "checkbox") {
          let answers = [];
          if (userAnswerArrayData[0]?.key) {
            userAnswerArrayData.forEach(answer => {
              answers.push(
                ["A", "B", "C", "D"][
                this.currentQuestionOptions.findIndex(
                  option =>
                    option.key === answer.key && option.value === answer.value
                )
                ]
              );
            });
          } else {
            userAnswerArrayData.forEach(answer => {
              answers.push(
                ["A", "B", "C", "D"][
                this.currentQuestionOptions.findIndex(
                  option => option === answer
                )
                ]
              );
            });
          }
          answers = answers.filter(res => {
            return res != undefined;
          });
          answerData = answers.join(",");
          this.userAnswerArray = [];
        }
        // console.log(this.userAnswer);
        // console.log(answerData);
        this.currentQuestion.userAnswer = answerData;
        let index = this.answeredQuestions.findIndex(item => {
          return item.id === this.currentQuestion.id;
        });
        if (index === -1) {
          this.answeredQuestions.push(this.currentQuestion);
        } else {
          this.answeredQuestions[index].userAnswer = answerData;
        }
        // console.log("this.userAnswer", this.currentQuestion);
        //// console.log(this.userAnswer)
        this.userAnswer = null;
      }
      this.currentQuestionIndex++;
      this.getNextQuestion("next");
    },
    submitExercise() {
      let exerciseData = [];
      const questionTypes = ["radio", "checkbox", "decide"]; // Change the order here
      for (const type of questionTypes) {
        const questions = this.exerciseData[type];
        for (const question of questions) {
          exerciseData.push(question);
        }
      }
      let answer = exerciseData.map(x => {
        return {
          answers: x.userAnswer ? x.userAnswer : "",
          id: x.id
        };
      });
      // console.log(exerciseData, answer);
      //// console.log("this.answeredQuestions", this.answeredQuestions);

      // let answer = this.answeredQuestions.map((x) => {
      //   return {
      //     answers: x.userAnswer ? x.userAnswer : "",
      //     id: x.id,
      //   };
      // });

      submitExerciseResult(
        {
          answers: answer,
          contentsId: this.contentsId
        },
        {
          Authorization: this.token,
          DeptId: this.dept
        }
      )
        .then(res => {
          if (res.code == 200) {
            this.scoreData = res.data;
            this.dialogVisible = true;
          }
          return;
        })
        .catch(err => {
          // console.log(err);
        });
    },
    reTest() {
      location.reload();
    },
    // 查看详情
    viewDetail() {
      getPaperResult(
        {
          contentsId: this.contentsId
        },
        {
          Authorization: this.token,
          DeptId: this.dept
        }
      )
        .then(res => {
          if (res.code == 200) {
            this.exerciseData = res.data;
            this.currentQuestionIndex = 0;
            this.dialogVisible = false;
            this.isResult = true;
            this.getNextQuestion(); this.jsshow = true
          }
          return;
        })
        .catch(err => {
          // console.log(err);
        });
    },
    goToLearn() {
      window.history.back();
    }
  }
};
</script>

<style >
.mayDn {

  /* margin-top: 10px; */
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  background: #f8f8f8;
}

.mylist {
  text-align: center;
  margin-top: 20px;
  width: 180px;
  margin-left: 20px;
  font-size: 18px;
}

.cw,
.zq {
  border-radius: 4px 4px 0 0;
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 100px;
  background: orangered;
  color: #fff;
  font-size: 15px;
}

.zq {
  background: #28bebe;
}

.contenttexte {
  padding: 10px;
  border: 1px solid #ccc;
  margin-top: 10px;
  border-radius: 14px;
}

.el-progress__text {
  font-size: 31px !important;
  margin-top: -10px !important;
  font-weight: bold !important;
}

.test-page {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.question-area {
  padding: 20px;
}

.question-area h2 {
  color: #3e63ee;
  font-size: 20px;
  border-left: 5px solid #3e63ee;
  padding-left: 24px;
  margin-left: -61px;
}

.answer-card-area {
  background-color: #e0e0e0;
  padding: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
}

button {
  margin-top: 10px;
}

.page-container11 {
  width: 100%;
  margin: 0 auto;
  margin-top: 120px;
}

.page-wrapper {
  width: 1200px;
  margin: 0 auto;
  /* padding: 100px; */
}

.page-back-wrapper {
  width: 100%;
  height: 68px;
  background: #ffffff;
  box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
  border-radius: 8px;
  border: 1px solid #f0f0f3;
  display: flex;
  align-items: center;
  margin-top: 18px;
}

.headT {
  position: absolute;
  padding-top: 20px;
  background: #ffffff;
}

.page-back-img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  display: inline-block;
  position: relative;
  top: 2px;
}

.page-back {
  display: flex;
  align-items: center;
  margin-left: 30px;
  cursor: pointer;
}

.page-title {
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  margin-left: 30px;
}

.content-container {
  display: flex;
  width: 100%;
  margin-top: 18px;
}

.content-left-container {
  flex: 1;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  display: flex;
}

.content-right-container {
  width: 452px;
  margin-left: 18px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  display: flex;
  flex: 0 0 auto;
}

.content-left-wrapper {
  flex: 1;
  margin: 24px 40px 120px 40px;
}

.content-right-wrapper {
  flex: 1;
  margin: 24px 30px 120px 30px;
}

.content-left-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
}

.clock-img {
  width: 28px;
  height: 28px;
  margin-right: 12px;
}

.exercise-title {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3e63ee;
  position: relative;
  margin-top: 13px;
}

.exercise-left-line {
  width: 6px;
  height: 24px;
  background: #3e63ee;
  border-radius: 3px;
  position: absolute;
  left: -40px;
  top: 5px;
}

.exercise-right-line {
  width: 6px;
  height: 24px;
  background: #3e63ee;
  border-radius: 3px;
  position: absolute;
  left: -30px;
  top: 5px;
}

.exercise-content-title {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 30px;
}

.exercise-options-wrapper {
  margin-top: 30px;
  min-height: 160px;
}

.exercise-options-wrapper>>>.el-radio__label {
  font-size: 20px !important;
  font-family: PingFangSC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #333333 !important;
}

.exercise-options-wrapper>>>.el-radio__inner {
  position: relative;
  top: -2px;
}

.exercise-options-wrapper>>>.el-checkbox__label {
  font-size: 19px !important;
  font-family: PingFangSC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #333333 !important;
}

.exercise-options-wrapper>>>.el-checkbox__inner {
  position: relative;
  top: -2px;
}

.exercise-options-wrapper>>>.el-checkbox__original {
  text-align: center !important;
}

.exercise-content-item {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}

.exercise-answer-container {
  margin-top: 96px;
  min-height: 200px;
}

.exercise-btn-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 45px;
}

.exercise-btn {
  width: 108px;
  height: 40px;
  background: #3e63ee;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  transition: 0.5s;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.exercise-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}

.exercise-answer-option-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.exercise-answer-option {
  width: 32px;
  height: 32px;
  margin-top: 15px;
  margin-right: 35px;
}

.answer-wrapper {
  width: 100%;
  height: 100%;
}

.answer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  border-radius: 50%;
  transition: 0.5s;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.answer:hover {
  cursor: pointer;
  opacity: 0.8;
}

.answer1 {
  color: #333333;
  border: solid #eaeaea 1px;
}

.answer2 {
  color: #fff;
  background: #ff9645;
  border: solid #ff9645 1px;
}

.answer3 {
  color: #fff;
  background: #4f79ed;
  border: solid #4f79ed 1px;
}

.answer-error {
  color: #fff;
  background: #eb6c48;
  border: solid #eb6c48 1px;
}

.answer-right {
  color: #fff;
  background: #28bebe;
  border: solid #28bebe 1px;
}

.answer-no {
  color: #333333;
  border: solid #eaeaea 1px;
}

.exercise-answer-info-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 36px;
  margin-top: 37px;
  border-top: 1px solid #eaeaea;
}

.exercise-answer-info-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.circle1 {
  background: #ff9645;
  border: solid #ff9645 1px;
}

.circle2 {
  background: #4f79ed;
  border: solid #4f79ed 1px;
}

.circle3 {
  border: 1px solid #eaeaea;
}

.circle-right {
  /* background: #eb6c48;
  border: solid #eb6c48 1px; */
  color: #fff !important;
  cursor: pointer;
}

.circle-right .yz {
  background-color: #FF9645 !important;
  border-color: #FF9645 !important;
  border-radius: 50%;
  color: #fff !important;
  cursor: pointer;
}

.circle-r {
  background: #28bebe;
  border: 1px solid #28bebe;
  /*color: #fff !important;*/
  /*cursor: pointer;*/
}

.circle-error {
  background: #eb6c48;
  border: solid #eb6c48 1px;
}

.exercise-answer-info-label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-left: 5px;
}

.exercise-answer-info {
  display: flex;
  align-items: center;
}

.circle-gap {
  margin-left: 50px;
  cursor: pointer;
}

.exercise-submit-btn {
  height: 40px;
  background: #3e63ee;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-top: 50px;
  transition: 0.5s;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.exercise-submit-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}

.exercise-answer-isRight-btn {
  width: 134px;
  height: 40px;
  background: #28bebe;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}

.exercise-answer-isError-btn {
  width: 134px;
  height: 40px;
  background: #eb6c48;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}

.right-img {
  width: 20px;
  height: 15px;
  margin-left: 14px;
}

.exercise-answer-isError-icon {
  display: inline-block;
  font-size: 22px;
  font-weight: 600;
  position: relative;
  left: 10px;
  top: 1px;
}

.exercise-answer-content {
  height: 110px;
  background: rgb(248, 248, 248);
  border-radius: 0px 8px 8px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exercise-answer-content-left {
  display: flex;
  align-items: center;
}

.exercise-answer-content-right {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303b45;
  margin-right: 18px;
}

.parse1-img {
  width: 24px;
  height: 27px;
  margin-right: 11px;
}

.exercise-answer-content-right:hover {
  cursor: pointer;
  opacity: 0.8;
}

.exercise-answer-content-right-answer-label {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303b45;
}

.exercise-answer-content-right-answer-value {
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #28bebe;
  margin-top: 6px;
}

.right-answer {
  margin-left: 18px;
  margin-right: 30px;
}

.my-answer {
  margin-left: 30px;
}

.answer-line {
  width: 1px;
  height: 47px;
  background: #e1e1e1;
}

.exercise-parse-container {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #cbcbcb;
  margin-top: 20px;
}

.exercise-parse-header {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  margin: 20px 0px 13px 17px;
}

.exercise-parse-content-wrapper {
  display: flex;
}

.exercise-parse-content {
  flex: 1;
  margin: 0px 26px 25px 18px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.dialog-container>>>.el-dialog__body {
  padding: 0px !important;
}

.dialog-container>>>.el-dialog__header {
  padding: 0px !important;
}

/* 试题详情 */
.cwlist>li {
  font-size: 20px;
  width: 600px;
  height: auto;
  white-space: pre-wrap;
  line-height: 40px;
  background: rgb(248, 248, 248);
  border-radius: 3px;
}

.dialog-header {
  width: 100%;
  height: 59px;
  background: #f8faff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}

.dialog-content {
  padding: 46px 77px 60px 77px;
}

.dialog-btn-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}

.dialog-content>>>.el-button {
  width: 148px !important;
  height: 40px !important;
  line-height: 40px !important;
  border-radius: 6px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 18px !important;
  font-family: PingFangSC-Regular, PingFang SC !important;
}

.dialog-content>>>.el-button--primary {
  background: linear-gradient(90deg, #5580f5 0%, #72a3f5 100%) !important;
}

.dialog-content>>>.el-button--default {
  border: 1px solid #4f79ed;
  color: #4f79ed !important;
}

.answerShow-border {
  width: 20px;
  height: 20px;
  border: solid #666666 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  position: relative;
  top: 1px;
}

.answerShow-border-right {
  width: 20px;
  height: 20px;
  border: solid #28bebe 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  position: relative;
  top: 1px;
  color: #28bebe;
}

.answerShow-border-error {
  width: 20px;
  height: 20px;
  border: solid #eb6c48 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  position: relative;
  top: 1px;
  color: #eb6c48;
}

.answerShow-container {
  display: flex;
  align-items: center;
}

.answerShow-radio {
  border-radius: 50%;
}

.answerShow-item-icon {
  font-size: 14px;
}

.answerShow-item-label {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-left: 15px;
}

.answerShow-item-label-right {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #28bebe;
  margin-left: 15px;
}

.exercise-options-wrapper .answer-value-wrap {
  margin-right: 15px;
}

.exercise-options-wrapper .answer-lable-wrap {
  display: inline-grid;
  white-space: pre-line;
  word-wrap: break-word;
  margin-right: 8px;
}

.answerShow-item-label-error {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #eb6c48;
  margin-left: 15px;
}

.dialog-btn {
  width: 140px;
  height: 38px;
  border-radius: 6px;
  border: 1px solid #3e63ee;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.dialog-deal-btn {
  background: #3e63ee;
  color: #fff;
}

.dialog-deal-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}

.dialog-info-label {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
}

.c-eb6c48 {
  color: #eb6c48 !important;
  border: 2px solid #eb6c48;
  border-radius: 4px;
}


.c-28bebe {
  color: #28bebe !important;
  border: 2px solid #28bebe;
  border-radius: 4px;
}

.back-eb6c48 {
  background-color: #eb6c48 !important;
  border-color: #eb6c48 !important;
  border-radius: 50%;
}

.back-28bebe {
  background-color: #28bebe !important;
  border-color: #28bebe !important;
  border-radius: 50%;
}

.question-info {
  display: inline-block;
  color: #000;
  text-align: center;
  margin: 20px 20px 20px 0;
  font-size: 12px;
  line-height: 32px;
  border: 1px solid #cccccc;
}

.el-checkbox__label,
.el-radio__label {
  font-size: 20px !important;
}



.el-checkbox__input {
  float: left;
}

.el-checkbox__label {

  /* 间距为2px */
  display: inline !important;
  width: 570px;

  word-wrap: break-word;
  display: inline-grid;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  height: auto;
  line-height: 30px !important;
  margin-top: -7px;
}

.el-checkbox__input,
.el-radio__input {
  margin-left: 10px;
}

.el-checkbox__input {
  margin-top: 2px;
  padding: 10px 0;
  line-height: 20px;
}
</style>